import React, { Component } from 'react';
import { Navbar,  NavbarBrand } from 'reactstrap';

class DTCHeader extends Component {
  render() {
    return (
      <div className="dtc-header">
        <Navbar light expand="lg" className="justify-content-between">
          <NavbarBrand className="text-hide" href="/">LendingUSA Portal</NavbarBrand>
          <div className="text-right phone">
            <h5>Questions?</h5>
            <h4 className="mb-0 text-danger">800-944-6177</h4>
          </div>
        </Navbar>
        <div className="progress-bar">
          <div className="progress-fill" style={{width: "67%"}}></div>
        </div>
      </div>
    );
  }
}

export default DTCHeader;
